// Import dependencies
import { unsafeCSS, css, html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';

// Import escapeHTML
import { escapeHTML } from '@wordpress/escape-html';

// Import i18n functions
import { __ } from '@wordpress/i18n';

// Import style for web component
import styles from './web-component-style.scss?inline';

// eslint-disable-next-line require-jsdoc
@customElement( 'uap-log-header-action-close-dialog' )
export class AutomatorLogHeaderActionCloseDialog extends LitElement {
	// Define style
	static styles = css`${ unsafeCSS( styles ) }`;

	// eslint-disable-next-line require-jsdoc
	render() {
		return html`
			<uo-tooltip>
				<span class="tooltip-nowrap">${ escapeHTML( __( 'Close log details', 'uncanny-automator' ) ) }</span>

				<uo-button
					slot="target"
					color="transparent"
					size="small"

					@click=${ this.requestCloseDialog }
				>
					<uo-icon id="xmark" size="16"></uo-icon>
				</uo-button>
			</uo-tooltip>
		`;
	}

	/**
	 * Requests the dialog to close itself
	 */
	requestCloseDialog() {
		this.dispatchEvent(
			new CustomEvent(
				'uap-log-request-dialog-close',
				{
					bubbles: true,
					composed: true
				}
			)
		);
	}
}